//BT-115300 : Implementing search functionality for News : Manasa B : 24/08/2023

import { memo, useState } from 'react';
import { BzHeading, BzCard } from '../../components';
import { Container, Row, Col } from 'react-bootstrap';
import { clearNewsaDetailsStates, scripWiseNewsData, sectorWiseNewsDetails } from '../../redux/actions/news';
import { useDispatch } from 'react-redux';
import { getApiExchangeNameFromMktSegId, getMktSegIdFromMappedMktSegId } from '../../utils/global_functions';
import { handleModal } from '../../redux/actions/modals';
import NewsDetailsModal from '../News/NewsDetailsModal';
const jtenantToken = 1;
const scripNewsPage = 5;

const TabNewsContent = ({ handleNewsOverview, arrNewsScrips, handleOnClickScrip, scripDetails, removeScrips, addScrips, onBuySellClick, handleOverview, nActiveCard, strSearchActiveTab, ...props }) => {
    const dispatch = useDispatch();
    const [selectedNews, setSelectedNews] = useState({});
    const [newsIcon,setNewsIcon] = useState(false);

    const handleDetails = (objActiveNewsData) => {
        dispatch(clearNewsaDetailsStates());
        if (objActiveNewsData.odin_code) {
            dispatch(scripWiseNewsData(objActiveNewsData.odin_code, getApiExchangeNameFromMktSegId(getMktSegIdFromMappedMktSegId(objActiveNewsData?.nSegmentId)), scripNewsPage, jtenantToken));
            dispatch(handleModal([{ "HOT_PURSUIT_DATA": true }]));
            setSelectedNews(objActiveNewsData);
        }
        else if (objActiveNewsData.SNo) {
            setNewsIcon(true)
            dispatch(sectorWiseNewsDetails(objActiveNewsData.SNo, jtenantToken));
            dispatch(handleModal([{ "NEWS_DETAILS": true }]));
        }
    };
    return (
        <>
            {/* Bhagyashri P [04-12-2023] : BT-96728 Global Search Feature - class changes Starts  */}
            <Container fluid className='px-3 p-0'>
                <div data-testid='global-search-news-result-element' className='pb-3'>
                    {arrNewsScrips?.length > 0 && arrNewsScrips?.map((each, i) => (
                        <BzCard key={i} className='p-0 my-3 bdr-btm global-search-focus' style={{ border: nActiveCard === i ? 'solid 1px' : null }} tabindex={nActiveCard === i ? 0 : -1} id={'globalsearchCard' + strSearchActiveTab + i} >
                            <Row className='g-0' >
                                <Col md={9} className='d-flex justify-content-start align-self-center chips-wrap'>
                                    <BzHeading className='font-medium cursor-pointer font-size3 color-text me-3'>{each?.news_content}</BzHeading>
                                </Col>
                                <Col md={3} className='d-flex justify-content-end align-self-center'>
                                    <div data-testid={`global-search-news-forward-icon-${i}`} className='icon-16 icon-forward-arrow icon-dark' onClick={(e) => { e.stopPropagation(); handleDetails(each); }} ></div>
                                </Col>
                            </Row>

                            <Row className='g-0 mb-3'>
                                <Col className='justify-content-start align-self-center'>
                                    <div className='mt-1'>
                                        <Row className='g-0'>
                                            <Col className='d-flex align-items-center'>
                                                <div className='chips-wrap float-start'>
                                                    {/* <BzChip className={`ms-2 chips  align-self-center`}>{each?.eventType}</BzChip> */}
                                                    <div className='font-regular font-size1 cursor-pointer color-subtext'>{each?.date_time}</div>
                                                </div>
                                            </Col>
                                        </Row>
                                    </div>
                                </Col>
                            </Row>
                        </BzCard>
                    ))}
                </div>
                {newsIcon?<NewsDetailsModal selectedNews={selectedNews} setSelectedNews={setSelectedNews} tab={"Hot Pursuit"} />:null}
            </Container>
            {/* Bhagyashri P [04-12-2023] : BT-96728 Global Search Feature - class changes Ends  */}

        </>
    );
};

export default memo(TabNewsContent);

//BT-115300 : Implementing search functionality for News : Manasa B : 24/08/2023


